import {
  Router,
  RouterModule,
  NavigationStart,
  Event as NavigationEvent,
} from "@angular/router";
import {
  IonIcon,
  IonList,
  IonMenu,
  IonContent,
  IonBackdrop,
  IonSplitPane,
  MenuController,
  IonRouterOutlet,
} from "@ionic/angular/standalone";
import {
  UserModel,
  DeviceModel,
  UserRolesModel,
} from "src/app/store/models/user.model";
import {
  SiteModel,
  SitesWithIncompleteAssets,
} from "src/app/store/models/asset.model";
import { Store } from "@ngrx/store";
import { AsyncPipe } from "@angular/common";
import { Platform } from "@ionic/angular/standalone";
import { Subject, Subscription, takeUntil } from "rxjs";
import { LoadingController } from "@ionic/angular/standalone";
import { OnInit, inject, Component, OnDestroy } from "@angular/core";
import { AuthService } from "src/app/services/auth-service/auth.service";
import { UserService } from "src/app/services/user-service/user.service";
import { AdminService } from "src/app/services/admin-service/admin.service";
import { ImagePreviewService } from "src/app/services/image-preview.service";
import { HttpService } from "src/app/services/http-service/http-client.service";
import { ImageLightboxComponent } from "../image-lightbox/image-lightbox.component";
import { FirebaseService } from "src/app/services/firebase-service/firebase.service";
import { CCModalService } from "src/app/services/performance-service/cc-modal.service";
import { CREModalService } from "src/app/services/performance-service/cre-modal.service";
import { BOGModalService } from "src/app/services/performance-service/bog-modal.service";
import { CCModalComponent } from "../performance-indicatoors/cc-modal/cc-modal.component";
import { AssessmentService } from "src/app/services/assessment-service/assessment.service";
import { CREModalComponent } from "../performance-indicatoors/cre-modal/cre-modal.component";
import { BOGModalComponent } from "../performance-indicatoors/bog-modal/bog-modal.component";
import { SummaryModalService } from "src/app/services/performance-service/summary-modal.service";
import { NotificationService } from "src/app/services/notification-service/notification.service";
import { ExcellenceModalService } from "src/app/services/performance-service/excellence-modal.service";
import { SummaryModalComponent } from "../performance-indicatoors/summary-modal/summary-modal.component";
import { SettingsMapService } from "src/app/services/settings-service/settings-map/settings-map.service";
import { AirEmissionModalService } from "src/app/services/performance-service/air-emission-modal.service";
import { FindingDetailsModalService } from "src/app/services/performance-service/finding-details-modal.service";
import { ExcellenceModalComponent } from "../performance-indicatoors/excellence-modal/excellence-modal.component";
import { RegisterMaterialService } from "src/app/services/settings-service/material-map/register-material.service";
import { AirEmissionModalComponent } from "../performance-indicatoors/air-emission-modal/air-emission-modal.component";
import { FindingDetailsModalComponent } from "../performance-indicatoors/finding-details-modal/finding-details-modal.component";
import { CITimerService } from "src/app/services/performance-service/citimer.service";
import { NetworkService } from "src/app/services/network-service/network.service";

interface Tab {
  id: string;
  title: string;
  route: string;
  activeIcon: string;
  inactiveIcon: string;
  hasAccess?: boolean;
  /** Shown to every role, no module permission check */
  openToAll?: boolean;
}

@Component({
  imports: [
    IonList,
    IonIcon,
    IonMenu,
    AsyncPipe,
    IonContent,
    IonBackdrop,
    RouterModule,
    IonSplitPane,
    IonRouterOutlet,
    ImageLightboxComponent,
    SummaryModalComponent,
    CREModalComponent,
    BOGModalComponent,
    ExcellenceModalComponent,
    CCModalComponent,
    AirEmissionModalComponent,
    FindingDetailsModalComponent,
  ],
  standalone: true,
  selector: "app-tabs-menu",
  templateUrl: "./tabs-menu.component.html",
  styleUrls: ["./tabs-menu.component.scss"],
})
export class TabsMenuComponent implements OnInit, OnDestroy {
  private store = inject(Store);
  private router = inject(Router);
  userService = inject(UserService);
  private platform = inject(Platform);
  private menuCtrl = inject(MenuController);
  private authService = inject(AuthService);
  private httpService = inject(HttpService);
  public adminService = inject(AdminService);
  assessmentService = inject(AssessmentService);
  public ciTimerService = inject(CITimerService);
  public settingMap = inject(SettingsMapService);
  private loadingCtrl = inject(LoadingController);
  imagePreviewService = inject(ImagePreviewService);
  summaryModalService = inject(SummaryModalService);
  creModalService = inject(CREModalService);
  bogModalService = inject(BOGModalService);
  excellenceModalService = inject(ExcellenceModalService);
  ccModalService = inject(CCModalService);
  airEmissionModalService = inject(AirEmissionModalService);
  findingDetailsModalService = inject(FindingDetailsModalService);
  private firebaseService = inject(FirebaseService);
  public notificationService = inject(NotificationService);
  public registerMaterialService = inject(RegisterMaterialService);
  private networkService = inject(NetworkService);

  isOffline: boolean = false;
  offlineEnabledTabs: string[] = ["dashboard", "assessment", "settings"];

  user: string;
  site: SiteModel;
  selectedTab: string;
  showTabsMenu: boolean;
  isErrorModal: boolean;
  private fcmToken: string;
  isNotificationMenu: boolean;
  isAdminUser: boolean = false;
  isOnlyEiUser: boolean = false;
  isAssessmentModalOpen: boolean;
  private deviceType: DeviceModel;
  role: UserRolesModel | undefined;
  sites: SitesWithIncompleteAssets[];
  private destroy$ = new Subject<void>();
  private sitesSubscriptions: Subscription;

  tabHeight = 77; // 52px tab height + 25px gap
  curveOffset = 8;
  curveTop: number | null = 8;
  curveBottom: number | null = null;

  bogProTabs: Tab[] = [
    {
      id: "dashboard",
      title: "dashboard",
      route: "/dashboard",
      inactiveIcon: "../../assets/tab-icons/dashboard.svg",
      activeIcon: "../../assets/tab-icons/dashboard-active.svg",
    },
    {
      id: "process_safety_assesment",
      title: "assessment",
      route: "/assessment",
      inactiveIcon: "../../assets/tab-icons/assessment.svg",
      activeIcon: "../../assets/tab-icons/assessment-active.svg",
    },
    {
      id: "ei",
      title: "energy-isolation",
      route: "/energy-isolation",
      inactiveIcon: "../../assets/tab-icons/energy.svg",
      activeIcon: "../../assets/tab-icons/energy-active.svg",
    },
    {
      id: "action_management",
      title: "action-management",
      route: "/action-management",
      inactiveIcon: "../../assets/tab-icons/action-management.svg",
      activeIcon: "../../assets/tab-icons/action-management-active.svg",
    },
    {
      id: "performance_dashboard",
      title: "performance-dashboard",
      route: "/performance-dashboard",
      inactiveIcon: "../../assets/tab-icons/performance-dashboard-inactive.svg",
      activeIcon: "../../assets/tab-icons/performance-dashboard-active.svg",
      // inactiveIcon: "../../assets/tab-icons/performance-dashboard.svg",
      // activeIcon: "../../assets/tab-icons/performance-dashboard-active.svg",
    },
  ];

  eiTabs: Tab[] = [
    {
      id: "ei",
      title: "energy-isolation",
      route: "/energy-isolation",
      inactiveIcon: "../../assets/tab-icons/energy.svg",
      activeIcon: "../../assets/tab-icons/energy-active.svg",
    },
    {
      id: "ei_settings",
      title: "ei-settings",
      route: "/ei-settings",
      inactiveIcon: "../../assets/tab-icons/settings-icon.svg",
      activeIcon: "../../assets/tab-icons/settings-icon-active.svg",
    },
  ];

  constructor() {
    this.sites = [];
    this.showTabsMenu = true;
    this.selectedTab = "dashboard";
    if (this.platform.is("ios")) this.deviceType = "ios";
    if (this.platform.is("android")) this.deviceType = "android";
  }

  ngOnInit() {
    this.networkService
      .onNetworkStatusChange()
      .pipe(takeUntil(this.destroy$))
      .subscribe((isConnected: boolean) => {
        this.isOffline = !isConnected;
      });

    // User store
    this.store
      .select("user")
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: UserModel) => {
        if (!user || !user.roles) return;
        if (user.email) this.user = user.email;
      });

    // Assessment modal
    this.assessmentService.isAssessmentModalOpen
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOpen: boolean) => {
        this.isAssessmentModalOpen = isOpen;
      });

    // Notification modal
    this.notificationService.isErrorModalOpen
      .pipe(takeUntil(this.destroy$))
      .subscribe((isError: boolean) => {
        this.isErrorModal = isError;
      });

    // Side menu
    this.notificationService.sideMenuBar
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOpen: boolean) => {
        this.isNotificationMenu = isOpen;
      });

    // Tab access
    this.bogProTabs.forEach((tab) => {
      if (tab.openToAll) {
        tab.hasAccess = true;
        return;
      }
      this.userService
        .hasUserAccessToModule(tab.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (hasAccess) => (tab.hasAccess = hasAccess),
          error: () => (tab.hasAccess = false),
        });
    });
    //// Tab access
    // this.bogProTabs.forEach((tab) => {
    //   this.userService
    //     .hasUserAccessToModule(tab.id)
    //     .pipe(takeUntil(this.destroy$))
    //     .subscribe({
    //       next: (hasAccess) => (tab.hasAccess = hasAccess),
    //       error: () => (tab.hasAccess = false),
    //     });
    // });

    // Router events
    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: NavigationEvent) => {
        if (!(event instanceof NavigationStart)) return;

        switch (true) {
          case event.url === "/dashboard":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "dashboard";
            this.adminService.adminToggleCollapse(false);
            this.updateCurvePosition();
            break;
          case event.url === "/map-view":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "map-view";
            this.updateCurvePosition();
            break;
          case event.url === "/settings":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "settings";
            this.updateCurvePosition();
            break;
          case event.url === "/assessment":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "assessment";
            this.updateCurvePosition();
            break;
          case event.url === "/asset-register":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "asset-register";
            this.updateCurvePosition();
            break;
          case event.url === "/action-management":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "action-management";
            this.updateCurvePosition();
            break;
          case event.url === "/sap-configuration":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "sap-configuration";
            this.updateCurvePosition();
            break;
          case event.url === "/connections":
            this.showTabsMenu = false;
            this.menuCtrl.enable(true);
            this.selectedTab = "connections";
            break;
          case event.url.includes("/connections/inventory-setup"):
            this.showTabsMenu = false;
            this.menuCtrl.enable(false);
            this.selectedTab = "connections";
            break;
          case event.url.includes("/connections/action-management"):
            this.showTabsMenu = false;
            this.menuCtrl.enable(false);
            this.selectedTab = "connections";
            break;
          case event.url.includes("/connections/view-logs"):
            this.showTabsMenu = false;
            this.menuCtrl.enable(false);
            this.selectedTab = "connections";
            break;
          case event.url === "/energy-isolation":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "energy-isolation";
            this.updateCurvePosition();
            break;
          case event.url === "/ei-settings":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "ei-settings";
            this.updateCurvePosition();
            break;
          case event.url === "/energy-isolation/change-language":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "energy-isolation";
            this.updateCurvePosition();
            break;
          case event.url.startsWith("/training"):
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "training";
            this.updateCurvePosition();
            break;

          case event.url === "/admin":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "admin";
            this.updateCurvePosition();
            break;

          // ✅ NEW: Performance Dashboard route
          case event.url === "/performance-dashboard":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "performance-dashboard";
            this.updateCurvePosition();
            break;

          // Mapping has no menu item: it opens from the dashboard's Mapping card
          case event.url === "/mapping":
            this.showTabsMenu = true;
            this.menuCtrl.enable(true);
            this.selectedTab = "dashboard";
            this.updateCurvePosition();
            break;

          default:
            this.showTabsMenu = false;
            this.menuCtrl.enable(false);
            this.selectedTab = "dashboard";
            this.updateCurvePosition();
            break;
        }
      });
  }

  private updateCurvePosition() {
    // Reset both positions before calculation
    this.curveTop = null;
    this.curveBottom = null;

    if (this.selectedTab === "dashboard") {
      this.curveTop = this.curveOffset;
    } else if (this.selectedTab === "settings") {
      this.userService.hasUserAccessToModule("admin").subscribe((has) => {
        this.curveBottom = has ? 118 : 34;
      });
    } else if (this.selectedTab === "training") {
      this.userService.hasUserAccessToModule("admin").subscribe((has) => {
        this.curveBottom = has ? 118 : 34;
      });
    } else if (this.selectedTab === "admin") {
      this.curveBottom = 34;
    } else if (this.selectedTab === "energy-isolation") {
      this.curveTop = this.curveOffset;
    } else {
      // This handles all bogProTabs including the new performance-dashboard tab
      const index = this.bogProTabs
        .filter((t) => t.hasAccess)
        .findIndex((t) => t.title === this.selectedTab);
      if (index !== -1) {
        this.curveTop = this.curveOffset + index * this.tabHeight;
      }
    }
  }

  isTabOfflineDisabled(tabTitle: string): boolean {
    return this.isOffline && !this.offlineEnabledTabs.includes(tabTitle);
  }

  handleBackdropClose() {
    this.notificationService.sideMenuBar.next(false);
  }

  async handleLogOut() {
    if (this.isOffline) return;

    const loading = await this.loadingCtrl.create({
      spinner: "bubbles",
      keyboardClose: true,
    });
    loading.present();

    const fcmToken = {
      token: this.fcmToken,
      type: this.deviceType,
    };
    this.httpService
      .SignOut({
        email: this.user,
        fcmToken: fcmToken.type && fcmToken.token ? fcmToken : undefined,
      })
      .subscribe({
        error: (err) => loading.dismiss(),
        complete: () => {
          this.authService.SignOut(loading);
        },
        next: () => {
          this.firebaseService.checkedInLocation(this.user);
          if (this.userService.userSubscription) {
            this.userService.userSubscription.unsubscribe();
            this.userService.allUsersSubscription?.unsubscribe();
          }
        },
      });
  }

  async setCurrentTab(tab: string) {
    if (this.isTabOfflineDisabled(tab)) return;

    this.selectedTab = tab;

    if (this.site && tab === "asset-register") {
      this.handleNavigateMapView(this.site);
    }

    if (this.site && this.site?.id && tab === "settings") {
      this.router.navigate([`/settings`]);
    }

    // Reset both positions before calculation
    this.curveTop = null;
    this.curveBottom = null;

    if (tab === "settings") {
      this.userService.hasUserAccessToModule("admin").subscribe((has) => {
        this.curveBottom = has ? 118 : 34;
      });
      return;
    }

    if (tab === "admin") {
      this.curveBottom = 34;
      return;
    }

    if (this.isOnlyEiUser && tab === "energy-isolation") {
      this.curveTop = this.curveOffset;
      return;
    }

    // This handles all bogProTabs including the new performance-dashboard tab
    const index = this.bogProTabs
      .filter((t) => t.hasAccess)
      .findIndex((t) => t.title === tab);

    if (index !== -1) {
      this.curveTop = this.curveOffset + index * this.tabHeight;
    }
  }

  handleNavigateMapView({ id }: SiteModel) {
    if (id) this.router.navigate([`/asset-register/asset-map-view/${id}`]);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.sitesSubscriptions) this.sitesSubscriptions.unsubscribe();
  }
}
